import angular, {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import _ from "lodash";

export function lasterKnappForInjisering() {
    return ["$compile", lasterKnapp]
}

/*
 * Direktiv som setter 'disabled' attributet på en knapp. Krever container-direktivet over seg i hierakiet.
 *
 * Om attributet laster-knapp-feilet="eventNavn" er spesifisert vil ferdigLastet eventet bli trigget via containeren,
 * som gjør at evt. andre disablede knapper med dette direktivet blir aktive igjen.
 */
export function lasterKnapp($compile): IDirective {
    return {
        require: "^lasterKnappContainer",
        restrict: 'A',
        link: ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, lasterKnappContainer: any) => {

            const opprinneligKnappTekst = $element.html();
            let feiletEvent: string;
            let okEvent: string;

            if (!_.isEmpty($attr['lasterKnappFeilet'])) feiletEvent = $attr['lasterKnappFeilet'];
            if (!_.isEmpty($attr['lasterKnappOk'])) okEvent = $attr['lasterKnappOk'];

            if (feiletEvent) {
                $scope.$on(feiletEvent, () => {
                    lasterKnappContainer.ferdigLastet();
                    visOpprinneligHtml()
                });
            }

            if (okEvent) {
                $scope.$on(okEvent, () => {
                    lasterKnappContainer.ferdigLastet();
                    visOpprinneligHtml()
                });
            }

            $scope.$on("laster", () => {
                $element.attr("disabled", "disabled");
            });

            $scope.$on("ferdigLastet", () => {
                $element.removeAttr("disabled");
            });

            $element.on('click', () => {
                $element.attr("disabled", "disabled");
                lasterKnappContainer.laster();
                visLasteIkon();
            });

            // Muterende metoder
            // per http://stackoverflow.com/questions/16656735/insert-directive-programatically-angular
            const ionSpinner = angular.element(document.createElement('ion-spinner'));
            const ionSpinnerEl = $compile(ionSpinner)($scope);

            const visLasteIkon = () => {
                $element.html(ionSpinnerEl);
            };

            const visOpprinneligHtml = () => {
                $element.html(opprinneligKnappTekst); // reset til opprinnelig tilstand/tekst.
            };
        }
    };
}
